module.exports = new __parcel__URL__("midground_mountains-min.fcc27b4f.png").toString();